import React from 'react';
import DashboardYearEvaluations from '@/features/dashboard-eval/components/DashboardYearEvaluations';
import ParentLayout from './ParentLayout';

export default function Layout() {
  return (
    <ParentLayout title="Evaluations">
      {function(params) {
        return (
          <>
            <DashboardYearEvaluations params={params} />
          </>
        );
      }}
    </ParentLayout>
  );
}
